import Preferences from '../plugins/preferences'
// import store from '../store'

export default [
  {
    path: '/onboarding',
    component: () => import('../views/Auth/Onboarding.vue'),
    meta: {
      layout: 'fullscreen',
      transition: {
        back: 'scale-transition',
        forward: 'fade-transition',
      },
    },
  },
  {
    path: '/auth/offboarding',
    component: () => import(
      '../views/Auth/Offboarding.vue'
    ),
    meta: {
      layout: 'focus',
      transition: 't-fade',
      layoutProps: { backButton: false },
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/auth',
    async beforeEnter(to, from, next) {
      try {
        const query = { ...to.query }
        const hasAccount = await Preferences.get('hasAccount')
        const redirectPath = hasAccount ? '/auth/login' : '/auth/signup'
        next({ path: redirectPath, query })
      } catch (error) {
        console.error('Error in /auth route beforeEnter:', error)
        // Default to signup if there's an error
        next({ path: '/auth/signup', query: { ...to.query } })
      }
    },
    // Note: Adding a component as a fallback to prevent route not found errors
    component: () => import('../views/Auth/Login.vue'),
  },
  {
    path: '/auth/signup',
    component: () =>{
      if (BUILD_TARGET === 'extension') {
        return import('../views/Auth/ExtAuth.vue')
      }
      return import('../views/Auth/Signup.vue')
    },
    meta: {
      requiresConsent: true,
      transition: {
        parallel: 't-none',
        forward: 't-expand',
      },
      layout: 'focus',
      layoutProps: { backButton: false },
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/auth/login',
    component: () => {
      if (BUILD_TARGET === 'extension') {
        return import('../views/Auth/ExtAuth.vue')
      }
      return import('../views/Auth/Login.vue')
    },
    // no requiresConsent: logging in creates no account. A social button here
    // that would create one is refused by the auth service without consent, and
    // the consent-error handler sends the visitor through onboarding and back.
    meta: {
      transition: {
        parallel: 't-none',
      },
      layout: 'focus',
      layoutProps: { backButton: false },
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/auth/login/forgot',
    component: () => import('../views/Auth/Forgot.vue'),
    meta: {
      layout: 'focus',
      layoutProps: { backButton: false },
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      transition: {
        parallel: 'scale-transition',
        back: 'scale-transition',
        forward: 'fade-transition',
      },
    },
  },
  {
    path: '/auth/user/recovery',
    component: () => import('../views/Auth/Recovery.vue'),
    meta: {
      layout: 'focus',
      skipOnboarding: true,
    },
  },
  {
    path: '/auth/mfa/revoke',
    component: () => import('../views/Auth/RevokeMfa.vue'),
    meta: {
      layout: 'focus',
    },
  },
  {
    path: '/auth/logout',
    component: () => import('../views/Auth/Logout.vue'),
  },
]
